var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _g, _rect4, _g2, _rect5, _g3, _rect6, _g4, _rect7, _g5, _rect8, _g6, _rect9, _g7, _rect10, _rect11, _g8, _rect12, _g9, _rect13, _g10, _rect14, _g11, _rect15, _g12, _rect16, _g13, _rect17, _g14, _rect18, _rect19, _g15, _rect20, _g16, _rect21, _g17, _rect22, _g18, _rect23, _g19, _rect24, _g20, _rect25, _g21, _rect26, _rect27, _g22, _rect28, _g23, _rect29, _g24, _rect30, _g25, _rect31, _g26, _rect32, _g27, _rect33, _g28, _rect34, _rect35, _g29, _rect36, _g30, _rect37, _g31, _rect38, _g32, _rect39, _g33, _rect40, _g34, _rect41, _g35, _rect42, _rect43, _g36, _rect44, _g37, _rect45, _g38, _rect46, _g39, _rect47, _g40, _rect48, _g41, _rect49, _g42, _path7, _path8, _path9, _path10, _rect50, _rect51, _g43, _rect52, _g44, _rect53, _g45, _rect54, _g46, _rect55, _g47, _rect56, _g48, _rect57, _g49, _rect58, _rect59, _g50, _rect60, _g51, _rect61, _g52, _rect62, _g53, _rect63, _g54, _rect64, _g55, _rect65, _g56, _rect66, _rect67, _g57, _rect68, _g58, _rect69, _g59, _rect70, _g60, _rect71, _g61, _rect72, _g62, _rect73, _g63, _rect74, _rect75, _g64, _rect76, _g65, _rect77, _g66, _rect78, _g67, _rect79, _g68, _rect80, _g69, _rect81, _g70, _path11, _path12, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDataViewMetrics = function SvgDataViewMetrics(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 99,
    viewBox: "0 0 160 99",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 98,
    rx: 2.5,
    fill: "white",
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10156 39.967L148.451 39.9358",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10156 33.0664L148.451 33.0351",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 61.8894H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 50.9282H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 56.4089H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 45.4328H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 35,
    width: 13,
    height: 3
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 35.8418,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 35.8418,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 34.3193,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 35,
    width: 11,
    height: 3
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 35.8418,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 34.3193,
    width: 16.3403,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 35,
    width: 14,
    height: 3
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 35.8418,
    width: 13.194,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 34.3193,
    width: 19.791,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 35,
    width: 8,
    height: 3
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 35.8418,
    width: 6.69851,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 34.3193,
    width: 13.2955,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 35,
    width: 8,
    height: 3
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 35.8418,
    width: 6.69851,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 34.3193,
    width: 13.2955,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 35,
    width: 14,
    height: 3
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 35.8418,
    width: 13.194,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 34.3193,
    width: 19.791,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 35,
    width: 7,
    height: 3
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 35.8418,
    width: 6.69851,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 34.3193,
    width: 13.2955,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 41,
    width: 13,
    height: 3
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 41.9313,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 41.9314,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 40.4089,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 41,
    width: 14,
    height: 3
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 41.9314,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 40.4089,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 41,
    width: 11,
    height: 3
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 41.9314,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 40.4089,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 41,
    width: 10,
    height: 3
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 41.9314,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 40.4089,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 41,
    width: 10,
    height: 3
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 41.9314,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 40.4089,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 41,
    width: 11,
    height: 3
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 41.9314,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 40.4089,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 41,
    width: 9,
    height: 3
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 41.9314,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 40.4089,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 47,
    width: 13,
    height: 2
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 47.412,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 47.4121,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 45.8896,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 47,
    width: 14,
    height: 2
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 47.4121,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 45.8896,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 47,
    width: 11,
    height: 2
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 47.4121,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 45.8896,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 47,
    width: 10,
    height: 2
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 47.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 45.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 47,
    width: 10,
    height: 2
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 47.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 45.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 47,
    width: 11,
    height: 2
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 47.4121,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 45.8896,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 47,
    width: 9,
    height: 2
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 47.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 45.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 52,
    width: 13,
    height: 3
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 52.994,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 52.9939,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 51.4717,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 52,
    width: 14,
    height: 3
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 52.9939,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 51.4717,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 52,
    width: 11,
    height: 3
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 52.9939,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 51.4717,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 52,
    width: 10,
    height: 3
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 52.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 51.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 52,
    width: 10,
    height: 3
  }, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 52.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 51.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 52,
    width: 11,
    height: 3
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 52.9939,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 51.4717,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 52,
    width: 9,
    height: 3
  }, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 52.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 51.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 58,
    width: 13,
    height: 2
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 58.4746,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 58.4746,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 56.9521,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 58,
    width: 14,
    height: 2
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 58.4746,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 56.9521,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 58,
    width: 11,
    height: 2
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 58.4746,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 56.9521,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 58,
    width: 10,
    height: 2
  }, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 58.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 56.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 58,
    width: 10,
    height: 2
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 58.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 56.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 58,
    width: 11,
    height: 2
  }, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 58.4746,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 56.9521,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 58,
    width: 9,
    height: 2
  }, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 58.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 56.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 63,
    width: 13,
    height: 3
  }, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 63.9551,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 63.9551,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 62.4329,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 63,
    width: 14,
    height: 3
  }, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 63.9551,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 62.4329,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 63,
    width: 11,
    height: 3
  }, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 63.9551,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 62.4329,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 63,
    width: 10,
    height: 3
  }, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 63.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 62.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 63,
    width: 10,
    height: 3
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 63.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 62.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 63,
    width: 11,
    height: 3
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 63.9551,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 62.4329,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 63,
    width: 9,
    height: 3
  }, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 63.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 62.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 83.8894H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 72.9282H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9 78.4089H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9 67.4328H148.552",
    stroke: "#E2E2EA",
    strokeWidth: 0.101493,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 69,
    width: 13,
    height: 2
  }, _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 69.412,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 69.4121,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 67.8896,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 69,
    width: 14,
    height: 2
  }, _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 69.4121,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 67.8896,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 69,
    width: 11,
    height: 2
  }, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 69.4121,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 67.8896,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 69,
    width: 10,
    height: 2
  }, _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 69.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 67.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 69,
    width: 10,
    height: 2
  }, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 69.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 67.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 69,
    width: 11,
    height: 2
  }, _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 69.4121,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 67.8896,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 69,
    width: 9,
    height: 2
  }, _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 69.4121,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 67.8896,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 74,
    width: 13,
    height: 3
  }, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 74.994,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 74.9939,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 73.4717,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 74,
    width: 14,
    height: 3
  }, _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 74.9939,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 73.4717,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 74,
    width: 11,
    height: 3
  }, _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 74.9939,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 73.4717,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 74,
    width: 10,
    height: 3
  }, _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 74.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 73.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 74,
    width: 10,
    height: 3
  }, _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 74.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 73.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 74,
    width: 11,
    height: 3
  }, _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 74.9939,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 73.4717,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 74,
    width: 9,
    height: 3
  }, _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 74.9939,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 73.4717,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 80,
    width: 13,
    height: 2
  }, _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 80.4746,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 80.4746,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 78.9521,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 80,
    width: 14,
    height: 2
  }, _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 80.4746,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 78.9521,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 80,
    width: 11,
    height: 2
  }, _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 80.4746,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 78.9521,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 80,
    width: 10,
    height: 2
  }, _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 80.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 78.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 80,
    width: 10,
    height: 2
  }, _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 80.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 78.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 80,
    width: 11,
    height: 2
  }, _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 80.4746,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 78.9521,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 80,
    width: 9,
    height: 2
  }, _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 80.4746,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 78.9521,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 85,
    width: 13,
    height: 3
  }, _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9583,
    y: 85.9552,
    width: 9.74328,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2686,
    y: 85.9551,
    width: 1.52239,
    height: 1.52239,
    rx: 0.304478,
    fill: "#ECECEC"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 84.4329,
    width: 17.7612,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 85,
    width: 14,
    height: 3
  }, _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3879,
    y: 85.9551,
    width: 12.7881,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.8059,
    y: 84.4329,
    width: 19.3851,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 85,
    width: 11,
    height: 3
  }, _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7881,
    y: 85.9551,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.2061,
    y: 84.4329,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 85,
    width: 10,
    height: 3
  }, _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6389,
    y: 85.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.0566,
    y: 84.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 85,
    width: 10,
    height: 3
  }, _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9939,
    y: 85.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.4121,
    y: 84.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 85,
    width: 11,
    height: 3
  }, _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 114.349,
    y: 85.9551,
    width: 10.1493,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.767,
    y: 84.4329,
    width: 16.7463,
    height: 4.56716,
    fill: "#979799"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_1403_19465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 85,
    width: 9,
    height: 3
  }, _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 138.2,
    y: 85.9551,
    width: 8.72836,
    height: 1.52239,
    rx: 0.761194,
    fill: "#ECECEC"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_1403_19465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.618,
    y: 84.4329,
    width: 15.3254,
    height: 4.56716,
    fill: "#979799"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.788 12.3633H147",
    stroke: "currentColor",
    strokeWidth: 0.210361,
    strokeLinecap: "square"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.3633H78.2119",
    stroke: "currentColor",
    strokeWidth: 0.210361,
    strokeLinecap: "square"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 18.704,
    y: 18.9413,
    width: 6.62637,
    height: 1.36735,
    rx: 0.683674,
    fill: "currentColor"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 81.8123,
    y: 10.001,
    width: 6.10047,
    height: 1.36735,
    rx: 0.683674,
    fill: "currentColor"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 13.024,
    y: 10.001,
    width: 8.72998,
    height: 1.36735,
    rx: 0.683674,
    fill: "currentColor"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 87.4919,
    y: 19.0464,
    width: 6.62637,
    height: 1.36735,
    rx: 0.683674,
    fill: "currentColor"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 107.792,
    y: 19.0464,
    width: 6.62637,
    height: 1.36735,
    rx: 0.683674,
    fill: "currentColor"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 129.354,
    y: 19.0464,
    width: 6.62637,
    height: 1.36735,
    rx: 0.683674,
    fill: "currentColor"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5657,
    y: 18.9413,
    width: 6.62637,
    height: 1.36735,
    rx: 0.683674,
    fill: "currentColor"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 39.0038,
    y: 18.9413,
    width: 6.62637,
    height: 1.36735,
    rx: 0.683674,
    fill: "currentColor"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4952,
    y: 14.4187,
    width: 10.8336,
    height: 1.36735,
    rx: 0.683674,
    fill: "currentColor"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 58.462,
    y: 14.4187,
    width: 10.8336,
    height: 1.36735,
    rx: 0.683674,
    fill: "currentColor"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 36.9001,
    y: 14.4187,
    width: 10.8336,
    height: 1.36735,
    rx: 0.683674,
    fill: "currentColor"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 85.2832,
    y: 14.5238,
    width: 10.8336,
    height: 1.36735,
    rx: 0.683674,
    fill: "currentColor"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 127.25,
    y: 14.5238,
    width: 10.8336,
    height: 1.36735,
    rx: 0.683674,
    fill: "currentColor"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 105.688,
    y: 14.5238,
    width: 10.8336,
    height: 1.36735,
    rx: 0.683674,
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDataViewMetrics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/data-view-metrics.5bd9670c.svg";
export { ForwardRef as ReactComponent };